import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["rows", "template"];

  connect() {
    this.element.querySelectorAll("[data-rate]").forEach((element) => {
      const sectionKey = element.dataset.section;
      const rateData = JSON.parse(element.dataset.rate || "[]");
      const container = this.element.querySelector(
        `[data-section="${sectionKey}"] [data-tariff-sections-target="rows"]`
      );
      //console.log(rateData)
      rateData.forEach((rate) => {
       // console.log('addinng row', rate)
        this.addRowWithData(sectionKey, rate, container);
      });
    });
  }

  addRow(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const sectionKey = button.dataset.section;
    const container = button
      .closest(".rate-section")
      .querySelector('[data-tariff-sections-target="rows"]');

    this.addRowWithData(sectionKey, {}, container);
  }

  addRowWithData(sectionKey, data, container) {
    const template = document.getElementById(`${sectionKey}_template`);

    // Fetch category and sub-category from the nearest .rate-section parent
    const sectionElement = container.closest(".rate-fields");
    const category = sectionElement.dataset.category;
    const subCategory = sectionElement.dataset.subCategory;

    if (template) {
      const content = document.importNode(template.content, true);
      content.querySelectorAll("input, select").forEach((input) => {
        const namePattern = new RegExp("tariffs\\[\\w+\\]\\[\\w+\\]");
        input.name = input.name.replace(
          namePattern,
          `tariffs[${category}][${subCategory}]`
        );
      });

      Object.entries(data).forEach(([key, value]) => {
        const input = content.querySelector(`[name$='[${key}]']`);
        if (input) input.value = value;
      });

      container.appendChild(content);
    } else {
      console.error("Template not found for section:", sectionKey);
    }
  }

  removeRow(event) {
    event.preventDefault();
    if (confirm("Are you sure you want to remove this row?")) {
      event.target.closest(".input-row").remove();
    }
  }
}
